export const tabs = {
  edit: 'Edycja',
  models: 'Modele',
  dependencies: 'Zależności',
  dimensions: 'Wymiary',
  cameras: 'Kamery',
  visibility: 'Widoczność',
  groups: 'Grupy',
  lights: 'Światła',
} as const
